import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';
import ErrorIcon from '@material-ui/icons/Error';

//- The same three colours Dashboard.js uses for its ftpGood / ftpWarning classes, pulled
//- into one place so a status means the same colour everywhere it is shown.
const statusMap = {
	good: { Icon: CheckCircleIcon, color: '#4CAF50' },
	success: { Icon: CheckCircleIcon, color: '#4CAF50' },
	warning: { Icon: WarningIcon, color: '#FFC107' },
	error: { Icon: ErrorIcon, color: '#f44336' },
};

class FMPStatusIcon extends PureComponent {
	render() {
		const { status, large, title } = this.props;

		const entry = statusMap[status];
		if (!entry) {
			return null;
		}

		const { Icon, color } = entry;
		return (
			<Icon
				titleAccess={title || status}
				style={{ color, fontSize: large ? 32 : 16, verticalAlign: 'middle' }}
			/>
		);
	}
}

FMPStatusIcon.propTypes = {
	status: PropTypes.oneOf(['good', 'success', 'warning', 'error']),
	large: PropTypes.bool,
	title: PropTypes.string,
};

export default FMPStatusIcon;
